import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Table, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Exp_Reset_report } from "../../../../store/actions/SuperAdminReports/SuperAdminReports";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SelectFilter from "../../../reusableComponents/selectFilter";
import isEmpty from "../../../../store/validation/is-Empty";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { FormControl, TextField } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import NoContent from "../../../reusableComponents/NoContentComponent";

const SuperAdminResetUnclearSettlement = (props) => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const onSuccess = () => {
    setLoading(false);
  };

  const [dateQuery, setDateQuery] = useState({});

  const [selected, setSelected] = useState([]);
  const [selectedIDs, setSelectedIDs] = useState([]);
  const [totalAmount, setTotalAmount] = useState("0.00");

  // Filter Data

  const [showFilter, setShowFilter] = useState(false);

  const [filter, setFilter] = useState({
    location: "",
    search: false,
  });

  const userFilter = [
    { title: "Restaurant Name", disabled: true },
    { title: "A-Z", disabled: false },
    { title: "Z-A", disabled: false },
    { title: "Total Amount", disabled: true },
    { title: `Low to High 🠑`, disabled: false },
    { title: "High to Low 🠓", disabled: false },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let filteredData =
    props.all_vendor_settlement && props.all_vendor_settlement.data;

  filteredData =
    filteredData &&
    filteredData.filter((item) => {
      return (
        item &&
        item.restaurant_name &&
        item.restaurant_name.toLowerCase().includes(search.toLowerCase())
      );
    });

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  // if (sort === "A-Z") {
  //   filteredData = filteredData.sort((a, b) => {
  //     if (a?.restaurant_name?.toLowerCase() < b?.restaurant_name?.toLowerCase())
  //       return -1;
  //     if (a?.restaurant_name?.toLowerCase() > b?.restaurant_name?.toLowerCase())
  //       return 1;
  //     return 0;
  //   });
  // } else if (sort === "Z-A") {
  //   filteredData = filteredData.sort((a, b) => {
  //     if (a?.restaurant_name?.toLowerCase() < b?.restaurant_name?.toLowerCase())
  //       return 1;
  //     if (a?.restaurant_name?.toLowerCase() > b?.restaurant_name?.toLowerCase())
  //       return -1;
  //     return 0;
  //   });
  // } else if (sort === "Low to High 🠑") {
  //   filteredData = filteredData.sort(
  //     (a, b) =>
  //       Number.parseFloat(
  //         a.scanAndPayPayAmount +
  //         a?.expPayAmount +
  //         a?.orderPayAmount +
  //         a?.orderTipAmount
  //       ).toFixed(2) -
  //       Number.parseFloat(
  //         b?.scanAndPayPayAmount +
  //         b?.expPayAmount +
  //         b?.orderPayAmount +
  //         b?.orderTipAmount
  //       ).toFixed(2)
  //   );
  // } else if (sort === "High to Low 🠓") {
  //   filteredData = filteredData.sort(
  //     (a, b) =>
  //       Number.parseFloat(
  //         b?.scanAndPayPayAmount +
  //         b?.expPayAmount +
  //         b?.orderPayAmount +
  //         b?.orderTipAmount
  //       ).toFixed(2) -
  //       Number.parseFloat(
  //         a?.scanAndPayPayAmount +
  //         a?.expPayAmount +
  //         a?.orderPayAmount +
  //         a?.orderTipAmount
  //       ).toFixed(2)
  //   );
  // }

  // if (filter.search) {
  //   if (filter.location)
  //     filteredData = filteredData.filter((item) => {
  //       return item?.city
  //         ?.toLowerCase()
  //         .includes(filter.location.toLowerCase());
  //     });
  // }

  const downloadData = {
    headers: [
      { label: "Restaurant Name", key: "name" },
      { label: "ID", key: "id" },
      { label: "Tip Amount", key: "tip" },
      { label: "Order Amount", key: "order" },
      { label: "Event Amount", key: "event" },
      { label: "Scan Amount", key: "scan" },
      { label: "Total Amount", key: "total" },
    ],
    data: filteredData
      ? filteredData?.map((ele) => {
        return {
          // name: ele?.restaurant_name,
          // id: ele?._id,
          // tip: ele?.orderTipAmount.toFixed(2),
          // order: ele?.orderPayAmount.toFixed(2),
          // event: ele?.expPayAmount.toFixed(2),
          // scan: ele?.scanAndPayPayAmount.toFixed(2),
          // total: (
          //   ele?.orderTipAmount +
          //   ele?.orderPayAmount +
          //   ele?.expPayAmount +
          //   ele?.scanAndPayPayAmount
          // ).toFixed(2),
        };
      })
      : [],
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      setLoading(true);
      const token = props.auth.user.accessToken;
      props.Exp_Reset_report(
        token,
        'CLEARED',
        dateQuery,
        'summary',
        onSuccess
      );
    }
  }, [dateQuery]);

  const [showSearch, setshowSearch] = useState(false);
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-12 pl-5 pr-5">
              <div className="d-flex justify-content-between align-items-center">
                <div className="super_admin_add_vendor mb-4">
                  <h5 className="main_header_text">
                    Reset to Unclear Report
                  </h5>
                </div>
                <div className="text-right" align="right">
                  <div className="f12-400">Report Run Date: {moment().format("Do MMM, YYYY")}</div>
                  <div className="d-flex mt-2">
                    <div className="f12-400">Report Range Date :</div>
                    <div className="f12-500 ml-2">
                      {moment(dateQuery?.startDate).format("ll")} -{" "}
                      {moment(dateQuery?.endDate).format("ll")}
                    </div>
                  </div>
                </div>
              </div>
              <Row>
                <Col md={3}>
                  {/* <div className="d-flex align-items-center justify-content-between">
                    <Image
                      onClick={() =>
                        // this.setState({ showSearch: !this.state.showSearch })
                        setshowSearch(!showSearch)
                      }
                      alt="Search"
                      title="Search"
                      width="80px"
                      src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                    />
                    <Image
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                      alt="Filter Icon"
                      onClick={() => setShowFilter(!showFilter)}
                    />
                    <Image
                      onClick={handleClick}
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {userFilter.map((ele, index) => {
                        return (
                          <MenuItem
                            value={ele.title}
                            key={index}
                            onClick={() => setSort(ele.title)}
                            disabled={ele.disabled}
                          >
                            {ele.title}
                          </MenuItem>
                        );
                      })}
                    </Menu>
                    <CSVDownloader
                      filename={"settlement"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div> */}
                </Col>
                <div className="col-5"></div>
                <Col md={4}>
                  <SelectFilter onDateChange={onDateChangeHandler()} />
                </Col>

                {showSearch && (
                  <div className="row super-admin-toptext-searchbar-icon">
                    <div className="col-6">
                      <div className="col-12 p-0">
                        <Form.Control
                          type="text"
                          placeholder="Search By Restaurant"
                          onChange={(e) => setSearch(e.target.value)}
                          value={search}
                          className="amSearch w-100"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {showFilter && (
                  <div
                    className="container-fluid p-4"
                    style={{
                      backgroundColor: "#ffffff",
                      transition: "height 2s",
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <TextField
                              id="outlined-flexible"
                              label="Location"
                              value={filter.location}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  location: e.target.value,
                                })
                              }
                              variant="outlined"
                            />
                          </FormControl>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="mt-5 d-flex">
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                        title="Cancel Button"
                        onClick={() => {
                          setFilter({
                            location: "",
                            search: false,
                          });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        title="Confirm Button"
                        onClick={() => {
                          setFilter({ ...filter, search: true });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                )}
              </Row>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table>
                    <thead>
                      <TableHead />
                    </thead>
                    {loading ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {filteredData?.length ?
                          filteredData.map((data, index) => (
                            <TableBody
                              key={index}
                              data={data}
                              startDate={dateQuery.startDate}
                              endDate={dateQuery.endDate}
                            />
                          )) : <NoContent />}
                      </>
                    )}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
SuperAdminResetUnclearSettlement.propTypes = {
  auth: PropTypes.object.isRequired,
  Exp_Reset_report: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_vendor_settlement:
    state.superadminManageTransactions.all_vendor_settlement,
});

export default connect(mapStateToProps, {
  Exp_Reset_report,
})(SuperAdminResetUnclearSettlement);

const TableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "15%" }}>
        My Experience <br />
        Experience ID
      </th>
      <th style={{ width: "10%" }}>
        Amount
      </th>
      <th style={{ width: "10%" }}>
        Transfer ID
      </th>
      <th style={{ width: "15%" }}>
        Reason
      </th>
      <th style={{ width: "15%" }}>
        Detailed <br />
        Reason
      </th>
      <th style={{ width: "12%" }}>
        Date & Time
      </th>
      <th style={{ width: "12%" }}>Actions</th>
    </tr>
  );
};

const TableBody = (props) => {

  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr>
                <td style={{ width: "15%" }}>
                  <div className="d-flex align-items-center">
                    <div className=" text-break ml-1">
                      <div className="f12-500">
                        {props.data.requestId?.experienceId?.name}
                      </div>
                      <div className="f10-400">{props.data.requestId?.experienceId?.expId}</div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.amount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {props?.data?.transactionDetails}
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-400">
                    {props?.data?.reason}
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-400">
                    {props?.data?.description}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-400">
                    {moment(props.data.createdAt).format('ll')}
                    {moment(props.data.createdAt).format('LT')}
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="d-flex align-items-center">
                    {/* <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={() => redirect(props.data, false)}
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/eye.svg")}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </Button>
                    <div
                      style={{ color: "#2196F3", cursor: "pointer" }}
                      onClick={() =>
                        redirectHistory(props.data.vendor_id._id, props.data)
                      }
                    >
                      {" "}
                      View <br />
                      History
                    </div> */}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const InitiatePayout = (props) => {
  const [state, setState] = useState(false);
  const handleClose = (e) => setState(!state);

  const history = useHistory();

  const handleClick = () => {
    if (props.selected.length) {
      setState(true);
    }
  };

  const onRedirect = () => {
    history.push("/superadmin/request-checkout", {
      data: props.selected,
      startDate: props.startDate,
      endDate: props.endDate,
    });
  };
  return (
    <React.Fragment>
      <div
        className={`btn ${props.selected.length ? "btn-danger" : "btn-secondary"
          } btn-sm`}
        onClick={handleClick}
      >
        Initiate Payout
      </div>
      <Modal show={state} onHide={handleClose} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f24-700">Confirm Initiate Payout</div>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="f24_700_HelveticaNeue w-75 m-auto pb-4"></div> */}
          <div className="f18-500 mt-2 mb-4">
            Are you sure you want to confirm initiate payout?
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-2"></div>
              <div className="col-4">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  // onClick={(e) =>
                  //   this.props.history.push("/subscriptiondescription")
                  // }
                  onClick={handleClose}
                >
                  No
                </Button>
              </div>
              <div className="col-4">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  // style={{ width: "90%" }}
                  onClick={onRedirect}
                >
                  Yes
                </Button>
              </div>
              <div className="col-2"></div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
